import { render, staticRenderFns } from "./peripherals.vue?vue&type=template&id=6a18af80"
import script from "./peripherals.vue?vue&type=script&lang=js"
export * from "./peripherals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports